import React from 'react'
import loadable from '@loadable/component'
import paths from 'app/paths'
import { Routes, Route, Outlet } from 'react-router-dom'
import { getPathWithoutBase } from 'components/tabs'
import RouteAuthorization from 'app/route-authorization'
import DelayedRedirect from 'components/delayed-redirect'

import IntegrationsPage from './pages/integrations'
const IntegrationPage = loadable(() => import(/* webpackPrefetch: true */ './pages/integration'))

const salt = 'integrations'

const IntegrationsRouting = () => {
    const { base } = paths.integrations
    const getRelativePath = getPathWithoutBase(base)

    return (
        <Routes>
            <Route element={<Outlet />}>
                <Route
                    index
                    element={(
                        <RouteAuthorization module="integrations">
                            <IntegrationsPage salt={salt} />
                        </RouteAuthorization>
                    )} />
                <Route
                    path={`${getRelativePath(paths.integrations.integration.base)}/*`}
                    element={(
                        <RouteAuthorization module="integrations">
                            <IntegrationPage salt={salt} />
                        </RouteAuthorization>
                    )} />
                <Route
                    path="*"
                    element={<DelayedRedirect to={base} />} />
            </Route>
        </Routes>
    )
}

export default IntegrationsRouting